import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle, booleanFormatter } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getUsers, deleteUser, updateUserNotifications } from '../../../../api/user'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';

function getData(admins) {
  let data = []
  for (let i = 0; i < admins.length; ++i) {
    if (admins[i].role === 'admin') {
      const elem = {}
      elem.name = admins[i].fullName
      elem.email = admins[i].email
      elem.notifications = admins[i].notifications
      elem.createdAt = admins[i].createdAt
      elem.id = admins[i]._id
      data = data.concat(elem)
    }
  }
  return data
}

export default function AdminsPage() {
  const [data, setData] = useState([])
  const [admin, setAdmin] = useState(null)
  const [adminId, setAdminId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    const elem = data.find(item => item.id === cell)
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-admin/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title={elem?.notifications ? "Disable notifications" : "Enable notifications"}>
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setAdmin(elem)
            setOpenConfirmDialog(2)
          }}>
          {elem?.notifications ? <NotificationsOffIcon/> : <NotificationsActiveIcon/>}
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setAdminId(cell)
            setOpenConfirmDialog(1)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }


  const columns = [
    { dataField: 'name', text: 'Full name', sort: true },
    { dataField: 'email', text: 'Email', sort: true },
    { dataField: 'notifications', text: 'notifications', align: 'center', headerAlign: 'center', formatter: booleanFormatter, sort: true },
    { dataField: 'createdAt', text: 'Created at', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getUsers().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get administrators.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Administrators list'>
          <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push('/edit-admin')}
              >
                Add new
              </button>
            </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={'Are you sure you want to remove this admin?'}
            open={openConfirmDialog === 1}
            setOpen={() => setOpenConfirmDialog(null)}
            onConfirm={() => {
              deleteUser(adminId).then(res => {
                if (res.status === 204 || res.status === 200) {
                  alertSuccess({  title: 'Deleted!', customMessage: 'Admin removed successfully.' })
                  setRefresh(true)
                }
              }).catch(error => {
                alertError({ error: error, customMessage: 'Could not remove admin.' })
              })
            }}
          />
          <ConfirmDialog
            title={`Are you sure you want to ${admin?.notifications ? 'disable' : 'enable'} notifications for this admin?`}
            open={openConfirmDialog === 2}
            setOpen={() => setOpenConfirmDialog(null)}
            onConfirm={() => {
              updateUserNotifications(admin.id, { notifications: !admin?.notifications, role: 'admin' }).then(res => {
                if (res.status === 204 || res.status === 200) {
                  alertSuccess({ title: `${admin?.notifications ? 'Disabled!' : 'Enabled!'}`, customMessage: `Notifications ${admin?.notifications ? 'disabled' : 'enabled'} successfully` })
                  setRefresh(true)
                }
              }).catch(error => {
                alertError({ error: error, customMessage: `Could not ${admin?.notifications ? 'disable' : 'enable'} notifications.` })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
